// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { restrictMovement, get, list } from "./operations.js";
export {
  VirtualMachinesRestrictMovementOptionalParams,
  VirtualMachinesGetOptionalParams,
  VirtualMachinesListOptionalParams,
} from "./options.js";
